<template>
    <div>
        <div class="loans">
            <div class="part-one">
                <div class="base-title">
                    <div class="part-one-content">
                        <img class="part-one-title-img" src="../assets/imgs/craft/part-1-title.png" alt="" />
                        <div class="part-text part-one-text">
                            为促进科技人才创业、科技成果转化和提高企业研发投入，满足科技企业精准化的融资服务需求，市科技局联合银行实施“人才贷”“成果贷”“研发贷”等一揽子产品，为符合条件的科技企业给予最高1000万元的授信支持。
                        </div>
                    </div>
                </div>
            </div>
            <div class="part-two">
                <img src="../assets/imgs/loans/title1.png" class="part-two-title-img" />
                <div class="part-text">
                    在蓉创新创业高层次人才所在的科技型中小微企业，在蓉开展科技成果转化、或实施科技研发项目的科技型中小微企业。
                </div>
            </div>
            <div class="part-three" style="padding-top: 1.5rem;">
                <img src="../assets/imgs/loans/title2.png" class="part-two-title-img" />
                <div class="part-three-items" style="padding-bottom: 0.3rem;">
                    <!-- <img src="../assets/imgs/loans/part2-label.png" class="part-three-items-img" /> -->
                    <div class="part-three-items-text">
                        给予50-1000万元的授信。
                    </div>
                </div>
            </div>
            <div class="part-four">
                <img src="../assets/imgs/loans/title3.png" class="part-two-title-img" />
                <div class="part-four-items" v-for="item in part4" :key="item.id" :style="item.boxHeight">
                    <img :src="item.titleImg" class="part-three-items-img" />
                    <div class="part-text">{{ item.title }}</div>
                    <div class="part-text rules" :style="index2 === item.noBottomIndex
                        ? 'margin-bottom:0'
                        : ''
                        " v-for="(item2, index2) in item.texts" :key="index2">
                        {{ item2 }}
                    </div>
                    <div class="part-text more-text" v-for="item3 in item.moreText" :key="item3.id">
                        {{ item3.text }}
                    </div>
                </div>
            </div>
            <div class="part-five">
                <img src="../assets/imgs/loans/title4.png" class="part-two-title-img" />
                <div class="part-text">
                    企业根据贷款需求，在“科创通”平台——成都创新创业服务平台<a style="text-decoration: none"
                        href="javascript:void">(http://www.cdkjfw.com/index.html)</a>进行申请。
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/24/part-5-tittle-add.png" alt="" />
                <div class="content">
                    全年。
                </div>
            </div>
            <div class="contact">
                <img class="top" src="./../assets/imgs/24/part-6-tittle.png" alt="" />
                <div class="content">
                    <div class="number">
                        <span class="label">政策咨询电话：</span>
                        <div>
                            <a href="tel:028-65575930">028-65575930</a>
                        </div>
                    </div>
                    <div class="unit">
                        <span class="label">责任单位：</span>
                        成都市生产力促进中心
                    </div>
                </div>
            </div>

            <div class="part-six">
                <img src="../assets/imgs/loans/code.png" style="
                                        width: 100%;
                                        height: 1.94rem;
                                        margin-right: 0.25rem;
                                    " />
                <!-- <img src="../assets/imgs/loans/code-text.png" style="width: 3.74rem; height: 1.5rem" alt="" /> -->
            </div>
            <!-- <div class="bottom-info">责任单位：成都市科学技术局科技金融处</div>
                            <div class="bottom-info" style="margin-top: 0.15rem">
                                咨询电话：
                            <a
                                href="tel:028-61881737"
                                >028-61881737</a
                            >
                            </div> -->
            <!-- <bottom
                                phone="028-61881737"
                                unit="成都市科学技术局科技金融处"
                            ></bottom> -->
        </div>
        <call phone="028-61881737" site="https://www.cdkjfw.com/tion/third.html?Id=NlJY@N5pAXLr/zNmm2Hn@g=="></call>
    </div>
</template>

<script>
// import bottom from "../components/bottom.vue";
import call from "../components/call.vue";

export default {
    name: "craft",
    data() {
        return {
            part4: [
                {
                    id: 1,
                    boxHeight: "",
                    titleImg: require("../assets/imgs/loans/part3-label1.png"),
                    title: "须同时具备以下条件：",
                    noBottomIndex: 2,
                    texts: [
                        "1.科技人才在成都创办具有独立法人资格的科技型企业；",
                        "2.科技人才为企业的创始人、法定代表人、实际控制人、技术负责人、大股东等；",
                        "3.科技人才符合下列条件之一：",
                    ],
                    moreText: [
                        {
                            id: 11,
                            text: "（1）中国国家最高科学技术奖获得者，国家自然科学奖、国家技术发明奖、国家科学技术进步奖获得者；省部级（含计划单列市）科学技术奖获得者；",
                        },
                        {
                            id: 21,
                            text: "（2）经中组部、科技部、教育部、人社部等批准或备案同意的副省级以上人才主管部门认定的人才引进计划入选者（含团队成员）；",
                        },
                        {
                            id: 31,
                            text: "（3）国家实验室、国家重点实验室等国家级创新平台全职科研人员，省（部）级重点实验室等创新平台负责人；",
                        },
                        {
                            id: 41,
                            text: "（4）“创青春”中国青年创新创业大赛、“互联网+”全国大学生创新创业大赛、中国创新创业大赛等由省级（含）以上政府部门主办或指导的科技类创新创业大赛获奖者，以及成都市政府部门主办的科技类创新创业大赛获奖者，获奖者年龄不超过45周岁；",
                        },
                        {
                            id: 51,
                            text: "（5）天府英才卡、蓉城人才绿卡持卡人；",
                        },
                        {
                            id: 61,
                            text: "（6） “蓉漂计划”入选者，成都市产业建圈强链人才计划入选者，成都市科技人才创业项目入选者，成都市“蓉贝”人才计划入选者；",
                        },
                        {
                            id: 81,
                            text: "（7）获得省级及以上部门职业技能竞赛前３名的高技能人才，成都市职业技能竞赛一类大赛前３名的高技能人才。",
                        },
                    ],
                },
                {
                    id: 2,
                    boxHeight: "",
                    titleImg: require("../assets/imgs/loans/part3-label2.png"),
                    title: "符合下列条件之一：",
                    noBottomIndex: 4,
                    texts: [
                        "1. 企业由成果完成人（团队）领（创）办，企业或成果完成人（团队）持有高校院所职务科技成果“分割确权”确认书（明确科技成果所有权权属比例）或者持有高校院所职务科技成果使用权协议书（成果完成人具有成果使用权）。",
                        "2.企业吸纳高校院所科技成果，在技术交易机构完成技术合同交易登记备案，并获得各类天使投资、创业投资以及成都知识产权运营基金、成都新经济发展基金等的支持。",
                        "3.企业获得有国家自然科学奖、国家技术发明奖、国家科学技术进步奖以及省部级（含计划单列市）科学技术进步奖的科技成果。",
                        "4.企业近年来获得有国家、省、市科技部门立项的重大科技成果转化、重大科技应用示范、重点新产品研发等各类科技项目。",
                        "5.企业近年来获得有国家授权的发明专利、实用新型专利等知识产权。",
                    ],
                    moreText: [],
                },
                {
                    id: 3,
                    boxHeight: "",
                    titleImg: require("../assets/imgs/loans/part3-label3.png"),
                    title: "须同时具备以下条件：",
                    noBottomIndex: 1,
                    texts: [
                        "1.有效期内高新技术企业；",
                        "2.近两年获得国家科技重大专项、国家重点研发计划、四川省重点研发计划（重大科技专项）、成都市重点研发支撑计划立项支持的研发项目承担单位。",
                    ],
                    moreText: [],
                },
            ],
        };
    },
    components: {
        // bottom,
        call,
    },
    created() { },
    mounted() { },
    computed: {},
    methods: {},
};
</script>

<style lang="scss" scoped>
.loans {
    background: #0839b7;
    overflow: hidden;
    padding: 0.24rem 0.12rem;
    padding-bottom: 1.65rem;
    box-sizing: border-box;
    width: 100vw;
    height: 100vh;
    overflow-y: auto;

    .part-title {
        font-size: 0.34rem;
        //font-family:: PingFang SC-Bold, PingFang SC;
        font-weight: bold;
        color: #333333;
        position: relative;

        &::before {
            position: absolute;
            content: "";
            width: 0.28rem;
            height: 0.28rem;
            border-radius: 50%;
            background: none;
            border: 0.06rem solid #ff6d60;
            box-sizing: border-box;
            top: 0.08rem;
            left: -0.2rem;
        }
    }

    .part-text {
        font-size: 0.26rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #4e4e4e;
        line-height: 0.44rem;
        text-align: left;
    }

    .part-one {
        height: 8rem;
        width: 7.5rem;
        margin: 0 auto;
        box-sizing: border-box;

        .base-title {
            width: 7.26rem;
            height: 5.6rem;
            background: url(../assets/imgs/loans/base-title.png);
            background-size: 100% 100%;
            position: relative;

            .part-one-content {
                width: 6.88rem;
                background: #ffffff;
                border-radius: 10px;
                position: absolute;
                top: 4.02rem;
                left: 50%;
                transform: translateX(-50%);
                padding-left: 0.36rem;
                padding-right: 0.37rem;
                padding-bottom: 0.35rem;
                box-sizing: border-box;

                .part-one-title-img {
                    position: absolute;
                    top: -0.32rem;
                    left: 0;
                    width: 6.86rem;
                    height: 1.12rem;

                }

                .part-one-title {
                    margin-top: 1.98rem;
                    text-align: left;
                    margin-left: 0.34rem;

                }

                .part-one-text {
                    // border: 1px solid red;
                    margin-top: 1.12rem;
                }
            }
        }
    }

    .part-two-title-img {
        width: 7.03rem;
        height: 1.37rem;
        top: 0;
        left: -0.18rem;
        position: absolute;
    }

    .part-three-items-img {
        position: absolute;
        width: 2.98rem;
        height: 0.67rem;
        left: 50%;
        transform: translateX(-50%);
        top: -0.32rem;
    }

    .part-two {
        margin-left: 0.02rem;
        width: 6.85rem;
        margin-top: 0.22rem;
        background: #fff;
        border-radius: 10px;
        padding-left: 0.53rem;
        padding-right: 0.3rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding-top: 1.5rem;
        padding-bottom: 0.35rem;
    }

    .part-three {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;
        padding: 1.92rem 0.25rem 0.35rem 0.25rem;

        .part-three-items {
            width: 6.35rem;
            background: #ffffff;
            border-radius: 10px;
            padding-top: 0.68rem;
            padding-left: 0.31rem;
            padding-right: 0.31rem;
            box-sizing: border-box;
            padding-bottom: 0.35rem;
            position: relative;

            .part-three-items-text {
                font-size: 0.26rem;
                //font-family:: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #4e4e4e;
                text-align: center;
            }
        }
    }

    .part-four {
        width: 6.85rem;
        background: #e8eeff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        padding: 2.04rem 0.25rem 0 0.25rem;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        border: 0.00001px solid transparent;
        position: relative;

        .part-four-items {
            width: 6.35rem;
            background: #ffffff;
            border-radius: 15px;
            position: relative;
            padding-left: 0.31rem;
            padding-right: 0.28rem;
            box-sizing: border-box;
            padding-top: 0.6rem;
            margin-bottom: 0.5rem;
            padding-bottom: 0.35rem;

            .rules {
                margin-bottom: 0.25rem;
            }

            .more-text {
                font-size: 0.26rem;
                margin-bottom: 0.1rem;
            }
        }
    }

    .part-five {
        width: 6.85rem;
        background: #ffffff;
        border-radius: 10px;
        margin-left: 0.02rem;
        margin-top: 0.22rem;
        padding: 1.5rem 0.25rem 0.35rem 0.25rem;
        box-sizing: border-box;
        display: inline-block;
        position: relative;
    }

    .part-six {
        width: 6.85rem;
        background: #ffffff;
        border-radius: 10px;
        box-sizing: border-box;
        margin: 0 auto;
        margin-top: 0.22rem;
        display: flex;
        padding: 0.35rem;
        align-items: center;
        justify-content: center;
    }

    .bottom-info {
        margin-top: 0.22rem;
        font-size: 0.24rem;
        //font-family:: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #97a9d9;

        a {
            text-decoration: none;
            // color: #97a9d9;
        }
    }
}
</style>
